import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.73541 1.71196C2.45279 1.42935 1.99458 1.42935 1.71196 1.71196C1.42935 1.99458 1.42935 2.45279 1.71196 2.73541L5.97656 7L1.71196 11.2646C1.42935 11.5472 1.42935 12.0054 1.71196 12.288C1.99458 12.5707 2.45279 12.5707 2.73541 12.288L7 8.02344L11.2646 12.288C11.5472 12.5707 12.0054 12.5707 12.288 12.288C12.5707 12.0054 12.5707 11.5472 12.288 11.2646L8.02344 7L12.288 2.73541C12.5707 2.45279 12.5707 1.99458 12.288 1.71196C12.0054 1.42935 11.5472 1.42935 11.2646 1.71196L7 5.97656L2.73541 1.71196Z",
      fill: "#64748B"
    }, null, -1)
  ]))]))
}
export default { render: render }